<template>
  <div>
    <div v-show="loading" class="flex justify-center mt3 iconColor">
      <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
    </div>
    <p v-show="!loading && !myPlaylists.length" class="pa2 center tc iconColor">{{ $t("artists.hasNotPlaylists") }}</p>
    <my-playlists-carousel v-show="!loading"  :playlists="myPlaylists" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PlaylistList from '@/components/playlists/PlaylistList.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import MyPlaylistsCarousel from '../carousel/MyPlaylistsCarousel.vue'

export default {
  name: 'my-playlists',
  data () {
    return {
      color: '#808080',
      size: '30px'
    }
  },
  created () {
    this.getMyPlaylists().catch((e) => {
      this.$toasted.show(this.error.message, {type: 'error'})
    })
  },
  components: {
    PlaylistList,
    ClipLoader,
    MyPlaylistsCarousel
  },
  computed: {
    ...mapGetters('user', [
      'myPlaylists',
      'error'
    ]),
    loading () {
      return this.$loading.isLoading('user getMyPlaylists')
    }
  },
  methods: {
    ...mapActions('user', [
      'getMyPlaylists'
    ])
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/user/MyPlaylists.vue